export class Helper {
  static isNextStep = false;
}
